import { defineMessages } from 'react-intl';

export default defineMessages({
    DepartmentNumber: {
        id: 'ml.common.component.MLPaymentEmployeeDetailsComponent.Department Number',
        defaultMessage: 'Department Number'
    },
    EmployeeNumber: {
        id: 'ml.common.component.MLPaymentEmployeeDetailsComponent.Employee Number',
        defaultMessage: 'Employee Number'
    },
    AlternateID: {
        id: 'ml.common.component.MLPaymentEmployeeDetailsComponent.Alternate ID',
        defaultMessage: 'Alternate ID'
    }
});